import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardTokenListComponent } from './card-token-list.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import { TopUpAddressModule } from '@fgb/portal-component-library/src/lib/shared/top-up-address';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { AddNewCardComponent } from './add-new-card/add-new-card.component';
import { CardTokenComponent } from './card-token/card-token.component';

@NgModule({
  declarations: [CardTokenListComponent, CardTokenComponent, AddNewCardComponent],
  imports: [
    LoadingModule,
    PipesModule,
    ConfirmModalModule,
    CountryAndRegionsModule,
    TopUpAddressModule,
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    LoadingModule,
    FGBSharedModule
  ],
  exports: [CardTokenListComponent, AddNewCardComponent],
})
export class CardTokenListModule {}
